import React from "react";
import { CentralIconBase, type CentralIconBaseProps } from "../CentralIconBase";

export const IconSidebarLeftArrow: React.FC<CentralIconBaseProps> = (props) => {
  return <CentralIconBase {...props} ariaLabel="sidebar-left-arrow"><path d="M15.25 9.75L13 12L15.25 14.25" stroke="currentColor" strokeWidth="1.5" strokeLinecap="square"/><path d="M3.75 3.75H20.25V20.25H3.75V3.75Z" stroke="currentColor" strokeWidth="1.5"/><path d="M8.25 3.75V20.25" stroke="currentColor" strokeWidth="1.5"/></CentralIconBase>;
};

export default IconSidebarLeftArrow;
